<template>
    <div>
        <!-- New Customer -->
        <div class="alert alert-secondary border-dark mt-3" v-if="!monthsPaid && pricing !== null">
            <h3 class="card-title">{{ $t('pages.subscription.start.billing.title') }}</h3>
            <p class="card-text" v-html="$t('pages.subscription.start.billing.explanation_pricing')"></p>

            <!-- text if no offer active and no coupon applied -->
            <p class="card-text"
               v-html="$t('pages.subscription.start.billing.explanation_first_month', {price: pricing.first_month.price_current})"
               v-if="pricing.first_month.discount_percentage === 0 && couponAmountOff === 0"></p>


            <!-- text is special offer active -->
            <p class="card-text"
               v-html="$t('pages.subscription.start.billing.explanation_first_month_special_offer', {
                   percentage: pricing.first_month.discount_percentage,
                   price_regular: pricing.first_month.price_regular,
                   price_now: pricing.first_month.price_current.toFixed(2).toString().replace('.', ',')
               })"
               v-else-if="pricing.first_month.discount_percentage > 0"></p>

            <!-- Text if coupon code applied -->
            <p class="card-text"
               v-html="$t('pages.subscription.start.billing.explanation_first_month_coupon_code', {
                   amount_off: (couponAmountOff / 100).toFixed(2).toString().replace('.', ','),
                   price_regular: pricing.first_month.price_regular,
                   price_now: priceFirstMonthWithCouponCodeRedeemed.toFixed(2).toString().replace('.', ',')
               })"
               v-else-if="couponAmountOff > 0"></p>
        </div>

        <!-- Paid between 1 and 11 months r -->
        <div class="alert alert-secondary border-dark" v-if="monthsPaid >= 1 && monthsPaid < 12">
            <h3 class="card-title">{{ $t('pages.subscription.start.billing.title') }}</h3>
            <p class="card-text" v-html="$t('pages.subscription.start.billing.subscription_standard_rate')"></p>
        </div>

        <!-- Paid 12 or more months -->
        <div class="alert alert-secondary border-dark" v-if="monthsPaid >= 12">
            <h3 class="card-title">{{ $t('pages.subscription.start.billing.title') }}</h3>
            <p class="card-text" v-html="$t('pages.subscription.start.billing.subscription_reduced_rate')"></p>
        </div>

        <static-loading-indicator-icon/>
<!--        <div class="card shadow-sm bg-light mb-4" v-show="!$store.getters.isExecutingRequest && monthsPaid === 0">-->
<!--            <div class="card-body">-->
<!--                <h4 class="card-title">-->
<!--                    {{ $t('pages.subscription.start.billing.coupon.title') }}-->
<!--                </h4>-->

<!--                <div class="form-group" v-if="!hasRedeemedCoupon">-->
<!--                    <label for="couponCode">{{ $t('pages.subscription.start.billing.coupon.input_label') }}</label>-->
<!--                    <input id="couponCode" class="form-control" type="text" v-model="couponCode"-->
<!--                           :placeholder="$t('pages.subscription.start.billing.coupon.input_label')">-->
<!--                </div>-->

<!--                <div v-if="hasRedeemedCoupon">-->
<!--                    <p v-html="$t('pages.subscription.start.billing.coupon.savings', {amount_off: (couponAmountOff / 100).toFixed(2).toString().replace('.', ','), coupon: couponUsed})"></p>-->

<!--                    <a class="text-danger mt-2 cursor-pointer" @click="unredeemCoupon">-->
<!--                        {{ $t('pages.subscription.start.billing.coupon.redeem_other') }}-->
<!--                    </a>-->
<!--                </div>-->

<!--                <button class="btn btn-gradient-primary" @click="redeemCoupon" v-if="!hasRedeemedCoupon">-->
<!--                    {{ $t('pages.subscription.start.billing.coupon.redeem') }}-->
<!--                </button>-->
<!--            </div>-->
<!--        </div>-->

        <div class="card shadow-sm bg-light mb-4" v-show="!$store.getters.isExecutingRequest && monthsPaid === 0">
            <div class="card-body">
                <h4 class="card-title">
                    {{ $t('pages.subscription.start.billing.partner.title') }}
                </h4>

                <div class="form-group" v-if="!hasValidatedPartnerCode">
                    <label for="partnerCode">
                        {{ $t('pages.subscription.start.billing.partner.input_label') }}<br>
                        {{ $t('pages.subscription.start.billing.partner.label_text') }}
                    </label>
                    <input id="partnerCode" class="form-control" type="text" v-model="partnerCode"
                           :placeholder="$t('pages.subscription.start.billing.partner.label_text')">
                </div>

                <div v-if="hasValidatedPartnerCode">
                    <img :src="referralPartnerLogoUrl" :alt="referralPartnerName" class="img-fluid mt-2 mb-2" style="max-width: 300px">
                    <p>{{ $t('pages.subscription.start.billing.partner.referred_by', {referrer: referralPartnerName}) }}</p>
                    <a class="text-danger mt-2 cursor-pointer" @click="invalidatePartnerCode">
                        {{ $t('pages.subscription.start.billing.partner.use_other') }}
                    </a>
                </div>

                <button class="btn btn-gradient-primary" @click="validatePartnerCode" v-if="!hasValidatedPartnerCode">
                    {{ $t('pages.subscription.start.billing.partner.use') }}
                </button>
            </div>
        </div>

        <form class="mt-3" @submit.prevent="confirmCardSetup">
            <div class="card shadow-sm bg-light" v-show="!$store.getters.isExecutingRequest">
                <div class="card-body">
                    <h4 class="card-title">{{ $t('pages.subscription.start.payment_method.title') }}</h4>

                    <div class="form-group">
                        <label for="card-holder">{{ $t('pages.subscription.start.payment_method.card_holder') }}</label>
                        <input id="card-holder" class="form-control" type="text" v-model="cardHolder"
                               placeholder="John Doe">
                    </div>


                    <div class="form-group">
                        <label for="card-number">{{
                                $t('pages.subscription.start.payment_method.credit_card_number')
                            }}</label>
                        <span id="card-number" ref="card" class="form-control stripe-element-container"></span>
                    </div>

                    <div class="row">
                        <div class="col-6">
                            <div class="form-group">
                                <label for="card-cvc">{{
                                        $t('pages.subscription.start.payment_method.cvc_number')
                                    }}</label>
                                <span id="card-cvc" class="form-control stripe-element-container"></span>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label for="card-exp">{{
                                        $t('pages.subscription.start.payment_method.expiration_date')
                                    }}</label>
                                <span id="card-exp" class="form-control stripe-element-container"></span>
                            </div>
                        </div>
                    </div>


                    <div class="alert alert-info"
                         v-html="$t('pages.subscription.subscribe_explanation_before_button', {price: priceInBeforeButtonText})"
                         v-if="!monthsPaid && pricing !== null"></div>


                    <button class="btn btn-gradient-primary" v-if="intent !== null"
                            :disabled="$store.getters.isExecutingRequest"
                            :class="{disabled: subscribeButtonDisabled}">
                        <span v-if="!monthsPaid">{{ $t('pages.subscription.subscribe_confirm_button') }}</span>
                        <span v-if="monthsPaid >= 1 && monthsPaid < 12">{{
                                $t('pages.subscription.subscribe_confirm_standard_rate_button')
                            }}</span>
                        <span v-if="monthsPaid >= 12">{{
                                $t('pages.subscription.subscribe_confirm_reduced_rate_button')
                            }}</span>
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import SubscriptionStartRepository from "../../../repositories/Subscription/SubscriptionStartRepository";
import StaticLoadingIndicatorIcon from "../../Includes/StaticLoadingIndicatorIcon";
import AuthRepository from "../../../repositories/Auth/AuthRepository";
import store from "../../../store/store";
import SubscriptionRepository from "../../../repositories/Subscription/SubscriptionRepository";
import SubscriptionPricingRepository from "../../../repositories/Subscription/SubscriptionPricingRepository";

let stripe = Stripe(process.env.MIX_STRIPE_KEY),
    elements = stripe.elements(),
    card = undefined;

let style = {
    base: {
        color: '#32325d',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
            color: '#aab7c4'
        }
    },
    invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
    }
};

export default {
    name: "SubscriptionStartBilling",
    components: {StaticLoadingIndicatorIcon},
    data: () => ({
        intent: null,
        cardHolder: '',
        card: null,
        cvc: null,
        exp: null,

        confirmCardSetupPressed: false,

        partnerCode: '',
        partnerCodeUsed: '',
        referralPartnerName: '',
        referralPartnerLogoUrl: '',

        couponCode: '',
        couponAmountOff: 0,
        couponUsed: '',

        pricing: null,

        monthsPaid: 0,
    }),
    mounted() {
        this.getSubscriptionStatus();
        this.getPricing();

        card = elements.create('cardNumber', {
            'placeholder': this.$t('pages.subscription.start.payment_method.credit_card_number'),
            'style': style
        });
        card.mount(this.$refs.card);

        // CVC
        this.cvc = elements.create('cardCvc', {
            'placeholder': '123',
            'style': style
        });
        this.cvc.mount('#card-cvc');

        // Card expiry
        this.exp = elements.create('cardExpiry', {
            'placeholder': 'MM/YY',
            'style': style
        });
        this.exp.mount('#card-exp');

        this.createSetupIntent();
    },
    beforeDestroy() {
        card.destroy(this.$refs.card);
        this.cvc.destroy('#card-cvc');
        this.exp.destroy('#card-exp');
    },
    computed: {
        subscribeButtonDisabled() {
            return this.$store.getters.isExecutingRequest || this.confirmCardSetupPressed;
        },
        hasRedeemedCoupon() {
            return this.couponUsed.length && this.couponAmountOff !== 0;
        },
        hasValidatedPartnerCode() {
            return this.partnerCodeUsed.length;
        },
        priceInBeforeButtonText() {
            if (this.hasRedeemedCoupon)
                return this.priceFirstMonthWithCouponCodeRedeemed.toFixed(2).toString().replace('.', ',');

            return this.pricing.first_month.price_current.toFixed(2).toString().replace('.', ',');
        },
        priceFirstMonthWithCouponCodeRedeemed() {
            return (((this.pricing.first_month.price_regular * 100) - this.couponAmountOff) / 100);
        },
    },
    methods: {
        invalidatePartnerCode() {
            this.referralPartnerName = '';
            this.referralPartnerLogoUrl = '';
            this.partnerCode = '';
            this.partnerCodeUsed = '';
        },
        validatePartnerCode() {
            SubscriptionStartRepository.validatePartnerCode(this.partnerCode).then((res) => {
                this.referralPartnerName = res.data.partner_name;
                this.referralPartnerLogoUrl = res.data.partner_logo_url;
                this.partnerCodeUsed = this.partnerCode;
                this.partnerCode = '';
            });
        },

        unredeemCoupon() {
            this.couponAmountOff = 0;
            this.couponUsed = '';
        },

        redeemCoupon() {
            SubscriptionStartRepository.redeemCoupon(this.couponCode).then((res) => {
                this.couponAmountOff = res.data.amount_off;
                this.couponUsed = res.data.coupon_code;
                this.couponCode = '';
            });
        },

        getPricing() {
            SubscriptionPricingRepository.getPricing().then((res) => {
                this.pricing = res.data;
            })
        },

        getSubscriptionStatus() {
            SubscriptionRepository
                .getStatus()
                .then((res) => {
                    this.monthsPaid = res.data.months_paid;
                });
        },

        createSetupIntent() {
            SubscriptionStartRepository
                .createSetupIntent()
                .then((res) => {
                    this.intent = res.data.intent;
                });
        },
        async confirmCardSetup() {
            if (this.confirmCardSetupPressed === true) {
                return false;
            }

            this.confirmCardSetupPressed = true;

            if (this.intent === null) {
                this.confirmCardSetupPressed = false;
                return false;
            }

            this.$store.commit('addRequestToLoadingStack', 'local');
            const {setupIntent, error} = await stripe.confirmCardSetup(
                this.intent.client_secret, {
                    payment_method: {
                        card: card,
                        billing_details: {name: this.cardHolder}
                    }
                }
            );

            if (error) {
                this.$store.commit('removeRequestFromLoadingStack', 'local');

                this.$snotify.error(error.message);
                this.createSetupIntent();
            } else {
                this.$store.commit('removeRequestFromLoadingStack', 'local');

                await SubscriptionStartRepository
                    .subscribe(setupIntent.payment_method, this.couponUsed, this.partnerCodeUsed)
                    .then((res) => {
                        AuthRepository
                            .fetchAuthDetails()
                            .then(() => {
                                this.$snotify.success(this.$t('pages.subscription.start.billing.subscription_successful'));
                                this.$router.push({name: 'subscription'});
                            });
                    })
                    .catch((error) => {
                        if (error.response.status === 409) {
                            console.log("409 reached")
                            console.log(error.response.data.incomplete_payment_handling_url);
                            if (typeof error.response.data.incomplete_payment_handling_url !== 'undefined') {
                                console.log("Url undefined")
                                window.location.replace(error.response.data.incomplete_payment_handling_url);
                            }
                        }
                        this.createSetupIntent()
                    });
            }
            this.confirmCardSetupPressed = false;
        }
    }
}
</script>

<style scoped>

</style>
